import React from "react";
import { Link } from "react-router-dom";
import { Plus, Check, ArrowRight } from "lucide-react";
import { useEnquiry } from "@/context/EnquiryContext";
import { imgUrl } from "@/lib/api";
import { toast } from "sonner";

const ProductCard = ({ product }) => {
  const { addItem, hasProduct } = useEnquiry();
  const added = hasProduct(product.id);

  return (
    <div className="group bg-white rounded-sm border border-[#004225]/10 overflow-hidden card-elevate flex flex-col" data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.id}`} className="block relative overflow-hidden">
        <div className="aspect-[4/3] bg-[#F4F4ED]">
          <img src={imgUrl(product.image)} alt={product.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        </div>
        <div className="absolute top-3 left-3 bg-white/95 backdrop-blur px-2 py-1 text-[10px] font-eyebrow text-[#004225] rounded-sm border border-[#004225]/10">{product.variety}</div>
      </Link>
      <div className="p-5 flex-1 flex flex-col">
        <div className="font-display text-xl text-[#004225] leading-tight">{product.name}</div>
        <div className="mt-1 text-[11px] font-eyebrow text-[#B5942D]">{product.type}</div>
        <div className="mt-3 text-[13px] text-[#171717]/75 space-y-1">
          <div><span className="text-[#171717]/50">Origin:</span> {product.origin}</div>
          <div><span className="text-[#171717]/50">Grain:</span> {product.grain}</div>
          <div><span className="text-[#171717]/50">MOQ:</span> {product.moq}</div>
        </div>
        <div className="mt-4 pt-4 border-t border-[#004225]/10 flex items-center gap-2">
          <button
            onClick={() => {
              if (added) { toast.info("Already in your enquiry"); return; }
              addItem(product);
              toast.success("Added to enquiry");
            }}
            data-testid={`add-to-enquiry-${product.id}`}
            className={`flex-1 inline-flex items-center justify-center gap-1.5 rounded-full px-3 py-2 text-[11px] font-semibold uppercase tracking-widest transition-colors ${
              added ? "bg-[#F7F2E2] text-[#004225]" : "btn-primary"
            }`}
          >
            {added ? (<><Check className="h-3.5 w-3.5" />In Enquiry</>) : (<><Plus className="h-3.5 w-3.5" />Add to Enquiry</>)}
          </button>
          <Link
            to={`/product/${product.id}`}
            data-testid={`view-product-${product.id}`}
            className="inline-flex items-center justify-center gap-1 rounded-full border border-[#004225]/20 text-[#004225] px-3 py-2 text-[11px] font-semibold uppercase tracking-widest hover:bg-[#F4F4ED]"
          >
            Details <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
